/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as SupportRouteImport } from './routes/support';
import { Route as PrivacyRouteImport } from './routes/privacy';
import { Route as GetRouteImport } from './routes/get';
import { Route as IndexRouteImport } from './routes/index';
import { Route as StandaloneSetupRouteImport } from './routes/standalone.setup';
import { Route as StandalonePlayRouteImport } from './routes/standalone.play';
import { Route as RoomCodeRouteImport } from './routes/room.$code';
import { Route as RCodeRouteImport } from './routes/r.$code';
import { Route as OnlineCreateRouteImport } from './routes/online.create';

const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any);
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any);
const GetRoute = GetRouteImport.update({
  id: '/get',
  path: '/get',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const StandaloneSetupRoute = StandaloneSetupRouteImport.update({
  id: '/standalone/setup',
  path: '/standalone/setup',
  getParentRoute: () => rootRouteImport,
} as any);
const StandalonePlayRoute = StandalonePlayRouteImport.update({
  id: '/standalone/play',
  path: '/standalone/play',
  getParentRoute: () => rootRouteImport,
} as any);
const RoomCodeRoute = RoomCodeRouteImport.update({
  id: '/room/$code',
  path: '/room/$code',
  getParentRoute: () => rootRouteImport,
} as any);
const RCodeRoute = RCodeRouteImport.update({
  id: '/r/$code',
  path: '/r/$code',
  getParentRoute: () => rootRouteImport,
} as any);
const OnlineCreateRoute = OnlineCreateRouteImport.update({
  id: '/online/create',
  path: '/online/create',
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/get': typeof GetRoute;
  '/privacy': typeof PrivacyRoute;
  '/support': typeof SupportRoute;
  '/online/create': typeof OnlineCreateRoute;
  '/r/$code': typeof RCodeRoute;
  '/room/$code': typeof RoomCodeRoute;
  '/standalone/play': typeof StandalonePlayRoute;
  '/standalone/setup': typeof StandaloneSetupRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/get': typeof GetRoute;
  '/privacy': typeof PrivacyRoute;
  '/support': typeof SupportRoute;
  '/online/create': typeof OnlineCreateRoute;
  '/r/$code': typeof RCodeRoute;
  '/room/$code': typeof RoomCodeRoute;
  '/standalone/play': typeof StandalonePlayRoute;
  '/standalone/setup': typeof StandaloneSetupRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/get': typeof GetRoute;
  '/privacy': typeof PrivacyRoute;
  '/support': typeof SupportRoute;
  '/online/create': typeof OnlineCreateRoute;
  '/r/$code': typeof RCodeRoute;
  '/room/$code': typeof RoomCodeRoute;
  '/standalone/play': typeof StandalonePlayRoute;
  '/standalone/setup': typeof StandaloneSetupRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/get'
    | '/privacy'
    | '/support'
    | '/online/create'
    | '/r/$code'
    | '/room/$code'
    | '/standalone/play'
    | '/standalone/setup';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/get'
    | '/privacy'
    | '/support'
    | '/online/create'
    | '/r/$code'
    | '/room/$code'
    | '/standalone/play'
    | '/standalone/setup';
  id:
    | '__root__'
    | '/'
    | '/get'
    | '/privacy'
    | '/support'
    | '/online/create'
    | '/r/$code'
    | '/room/$code'
    | '/standalone/play'
    | '/standalone/setup';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  GetRoute: typeof GetRoute;
  PrivacyRoute: typeof PrivacyRoute;
  SupportRoute: typeof SupportRoute;
  OnlineCreateRoute: typeof OnlineCreateRoute;
  RCodeRoute: typeof RCodeRoute;
  RoomCodeRoute: typeof RoomCodeRoute;
  StandalonePlayRoute: typeof StandalonePlayRoute;
  StandaloneSetupRoute: typeof StandaloneSetupRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/support': {
      id: '/support';
      path: '/support';
      fullPath: '/support';
      preLoaderRoute: typeof SupportRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/privacy': {
      id: '/privacy';
      path: '/privacy';
      fullPath: '/privacy';
      preLoaderRoute: typeof PrivacyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/get': {
      id: '/get';
      path: '/get';
      fullPath: '/get';
      preLoaderRoute: typeof GetRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/standalone/setup': {
      id: '/standalone/setup';
      path: '/standalone/setup';
      fullPath: '/standalone/setup';
      preLoaderRoute: typeof StandaloneSetupRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/standalone/play': {
      id: '/standalone/play';
      path: '/standalone/play';
      fullPath: '/standalone/play';
      preLoaderRoute: typeof StandalonePlayRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/room/$code': {
      id: '/room/$code';
      path: '/room/$code';
      fullPath: '/room/$code';
      preLoaderRoute: typeof RoomCodeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/r/$code': {
      id: '/r/$code';
      path: '/r/$code';
      fullPath: '/r/$code';
      preLoaderRoute: typeof RCodeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/online/create': {
      id: '/online/create';
      path: '/online/create';
      fullPath: '/online/create';
      preLoaderRoute: typeof OnlineCreateRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  GetRoute: GetRoute,
  PrivacyRoute: PrivacyRoute,
  SupportRoute: SupportRoute,
  OnlineCreateRoute: OnlineCreateRoute,
  RCodeRoute: RCodeRoute,
  RoomCodeRoute: RoomCodeRoute,
  StandalonePlayRoute: StandalonePlayRoute,
  StandaloneSetupRoute: StandaloneSetupRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
